import ObjectID from 'bson-objectid';

export function removeLeadingChars(value: string, char: string) {
  var sliceIdx = 0;
  for (var i = 0; i < value.length; i++) {
    if (value[i] === char) sliceIdx++;
    else break;
  }

  if (sliceIdx > 0) value = value.substring(sliceIdx);

  return value;
}

export const isValidObjectId = (id: string): boolean => {
  return /^[0-9a-fA-F]{24}$/.test(id) && ObjectID.isValid(id);
};
